import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  link: {
    textDecoration: "none",
    borderRadius: 10,
    margin: "2px 12px",
    padding: "9px 12px",
    transition: "background-color .15s ease, color .15s ease",
    "&:hover, &:focus": {
      backgroundColor: "#f1f5fb",
    },
  },
  externalLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    width: "100%",
  },
  linkActive: {
    backgroundColor: "#e8f0fe",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      left: -12,
      top: 6,
      bottom: 6,
      width: 4,
      borderRadius: "0 4px 4px 0",
      backgroundColor: "#1769d6",
    },
    "&:hover, &:focus": {
      backgroundColor: "#e0ebfd",
    },
  },
  linkNested: {
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 6,
    margin: "1px 12px 1px 0",
    borderRadius: 8,
    "&:hover, &:focus": {
      backgroundColor: "#f1f5fb",
    },
  },
  linkIcon: {
    marginRight: 12,
    minWidth: 0,
    color: "#7888a0",
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("color"),
    "& img": { width: 20, height: 20, objectFit: "contain" },
    "& svg": { fontSize: 21 },
  },
  linkIconActive: {
    color: "#1769d6",
  },
  linkText: {
    padding: 0,
    color: "#46566b",
    fontSize: 14.5,
    fontWeight: 500,
    transition: theme.transitions.create(["opacity", "color"]),
  },
  linkTextActive: {
    color: "#1769d6",
    fontWeight: 600,
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    position: "relative",
    marginLeft: 34,
    paddingLeft: 6,
    marginTop: 2,
    marginBottom: 4,
    borderLeft: "1.5px solid #e3e8f0",
  },
  sectionTitle: {
    marginLeft: 22,
    marginTop: 14,
    marginBottom: 6,
    color: "#9aa6b6",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  divider: {
    margin: "10px 16px",
    height: 1,
    backgroundColor: "#eceff4",
  },
  expandIcon: {
    color: "#9aa6b6",
    fontSize: 20,
  },
  nestedDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: "#c2ccda",
    marginLeft: 4,
    marginRight: 16,
    flexShrink: 0,
    transition: theme.transitions.create("background-color"),
  },
  nestedDotActive: {
    backgroundColor: "#1769d6",
  },
  nestedIcon: {
    marginLeft: 2,
    marginRight: 12,
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#7888a0",
    "& img": { width: 18, height: 18, objectFit: "contain" },
    "& svg": { fontSize: 19 },
  },
  nestedBullet: {
    fontSize: 9,
    marginLeft: 6,
    marginRight: 17,
    color: "#c2ccda",
    flexShrink: 0,
    transition: theme.transitions.create("color"),
  },
}));
